module.exports = __webpack_public_path__ + "img/Adobe_Analytics_Logo.04a6b7b1.svg";